import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Snackbar, Alert } from "@mui/material";
import { sendEmailBookingsAction } from "../../../../redux/Auth/AuthSlice";
import {
  getBookingHistoryDetail,
  updateBookingStatusAction,
} from "../../../../redux/booking/BookingSlice";
import ConfirmedBg from "../../../../Asset/image/yacht/ConfirmedBg.png";
import Confirmed from "../../../../Asset/image/yacht/Comfirmed.svg";
import { useTranslation } from "react-i18next";

const EmailActionPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const todos = useSelector((state) => state);
  const getToken = useSelector((state) => state.AuthSlice.token);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(getBookingHistoryDetail({ token: getToken }));
        setLoading(false);
      } catch (error) {
        console.error("Error fetching booking history:", error);
      }
    };

    fetchData();
  }, [dispatch, getToken]);

  const recipient = searchParams.get("recipient");
  const email = searchParams.get("email");
  const firstName = searchParams.get("firstName");
  const lastName = searchParams.get("lastName");
  const id_booking = searchParams.get("id_booking");
  const booking_no = searchParams.get("booking_no");
  const status = searchParams.get("status");

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // const handleConfirm = async () => {
  //   if (
  //     !recipient ||
  //     !email ||
  //     !firstName ||
  //     !lastName ||
  //     !status ||
  //     !id_booking
  //   ) {
  //     setSnackbar({
  //       open: true,
  //       message: t("Missing required parameters."),
  //       severity: "error",
  //     });
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     await dispatch(
  //       sendEmailBookingsAction({
  //         recipient,
  //         email,
  //         firstName,
  //         lastName,
  //         status,
  //         id_booking,
  //         booking_no,
  //       })
  //     );

  //     await dispatch(
  //       updateBookingStatusAction({ id_booking, status }, getToken)
  //     );

  //     setSnackbar({
  //       open: true,
  //       message: t("bookingStatusUpdated", { status }),
  //       severity: "success",
  //     });
  //   } catch (error) {
  //     console.error("Failed to send email or update booking status:", error);
  //     setSnackbar({
  //       open: true,
  //       message: t("Failed to send email or update booking."),
  //       severity: "error",
  //     });
  //   } finally {
  //     setLoading(false);
  //     if (window.opener || window.history.length <= 1) {
  //       window.close();
  //     }
  //   }
  // };

  const handleConfirm = async () => {
    if (
      !recipient ||
      !email ||
      !firstName ||
      !lastName ||
      !status ||
      !id_booking
    ) {
      setSnackbar({
        open: true,
        message: t("Missing required parameters."),
        severity: "error",
      });
      return;
    }

    setLoading(true);

    try {
      const res = await dispatch(
        updateBookingStatusAction({ id_booking, status }, getToken)
      );

      console.log("UPDATE RESULT:", res);

      // ✅ เช็คจาก API response (boolean)
      if (res?.status === true) {
        await dispatch(
          sendEmailBookingsAction({
            recipient,
            email,
            firstName,
            lastName,
            status,
            id_booking,
            booking_no,
          })
        );

        setSnackbar({
          open: true,
          message: t("Booking availability updated", { status }),
          severity: "success",
        });
        setTimeout(() => {
          window.close(); // หรือเปลี่ยนเป็น navigate(...) ก็ได้
        }, 2000);
      } else {
        setSnackbar({
          open: true,
          message:
            res?.msg || t("You cannot perform this action again."),
          severity: "warning",
        });
        setTimeout(() => {
          window.close(); // หรือเปลี่ยนเป็น navigate(...) ก็ได้
        }, 2000);
      }

    } catch (error) {
      console.error("Failed:", error);
      setSnackbar({
        open: true,
        message: t("Failed to update booking."),
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // แสดงข้อความเตือนถ้าพารามิเตอร์ไม่ครบ
  if (!recipient || !email || !firstName || !lastName || !id_booking) {
    return (
      <h2 className="text-center-mt50">
        {t("Missing required parameters.")}
      </h2>
    );
  }

  return (
    <div
      className="confirmed-page"
      style={{
        backgroundImage: `url(${ConfirmedBg})`,
      }}
    >
      {/* วงกลมพื้นหลังสีขาวด้านหลังกล่อง */}
      <div
        className="confirmation-circle-bg"
      />

      {/* กล่องหลัก */}
      <div
        className="confirmation-card"
      >
        <div
          className="confirmation-card-shadow"
        />
        {/* ไอคอนวงใน */}
        <div
          className="confirmation-icon-wrapper"
        >
          <img
            src={Confirmed}
            alt="Confirmed"
            className="icon-size-140"
          />
        </div>

        {/* Title */}
        <h2
          className="confirmation-title"
        >
          {t("Confirm Availability")}
        </h2>

        {/* Content */}
        <div
          className="confirmation-text"
        >
          <p>
            <strong>{t("Recipient")} :</strong>{" "}
            <span className="text-lowercase">{recipient}</span>
            <br />
            <strong>{t("Email")} :</strong>{" "}
            <span className="text-lowercase">{email}</span>
            <br />
            <strong>{t("Name")} :</strong> {firstName} {lastName}
            <br />
            <strong>{t("Selected Status")} :</strong>{" "}
            <span className="text-uppercase">{status}</span>
          </p>
        </div>

        {/* Confirm button */}
        {!message && (
          <button
            onClick={handleConfirm}
            disabled={loading}
            className="confirmation-button"
            style={{
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? t("Processing...") : t("Confirm")}
          </button>
        )}

        {message && <p>{message}</p>}
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          width: "auto",
        }}
      >
        <Alert
          sx={{
            borderRadius: 8,
          }}
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default EmailActionPage;
